import { useSelector } from 'react-redux';

import { RootState } from '../../../init-store';

export const useTypedSelector = useSelector.withTypes<RootState>();
